





























import { Component, Vue } from 'vue-property-decorator';
import { SearchResult } from '@/types/SearchResult';
import { Vessel } from '@/types/entities/Vessel';
import { CLEAR_VESSELS, SEARCH_VESSELS, SET_PAGE, SET_VESSEL_FILTER } from '@/store/vessels';
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading';
import PlusIcon from '@/svg/plus.svg';
import VesselCard from '@/components/Vessels/VesselCard.vue';
import SearchVesselMobileInput from '@/components/SearchVesselMobileInput.vue';

@Component({
  components: { SearchVesselMobileInput, VesselCard, PlusIcon, InfiniteLoading }
})
export default class List extends Vue {
  get vessels(): SearchResult<Vessel> {
    return this.$store.state.vessels.items.data;
  }

  public beforeRouteEnter(_: any, __: any, next: any) {
    next((vm: List) => {
      vm.$store.commit(CLEAR_VESSELS);
      vm.$store.commit(SET_VESSEL_FILTER, { seller_id: vm.$store.state.users.profile.id, active: null });
      vm.$store.dispatch(SEARCH_VESSELS);
    });
  }

  protected loadMore($state: StateChanger) {
    this.$store.commit(SET_PAGE, this.$store.state.vessels.page.number + 1);

    return this.$store.dispatch(SEARCH_VESSELS)
      .then((response) => {
        if (response.data.length) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
  }
}
